import Header from '../Header';
import Navigation from '../Navigation';
import './AppBar.scss';

const AppBar = () => {
  return (
    <Header>
      <Navigation />
    </Header>
  );
};

export default AppBar;
